import "./App.css";
import { Outlet } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import "react-toastify/dist/ReactToastify.css";
import ScrollToTop from "./components/ScrollToTop";
import PathChangeDrawer from "./components/PathChangeDrawer";

function App() {
  return (
    <>
      {/* <ToastContainer position="top-center" /> */}
      {/* <SmoothScroll>
        <main>
          <Header />
          <Outlet />
          <Footer />
        </main>
      </SmoothScroll> */}
      <PathChangeDrawer />
      <main className="relative scroll-smooth overflow-hidden text-primary-bg-blue">
        <ScrollToTop />
        <Header />
        <Outlet />
        <Footer />
      </main>
    </>
  );
}

export default App;
/* <SmoothScroll>
      
        <main>
          <Outlet />
        </main>
        <Footer />
      </SmoothScroll> */
